// extracted by mini-css-extract-plugin
export default {"layoutContainer":"Layout_layoutContainer__HOrtJ","mainContent":"Layout_mainContent__6OoEY"};